/**
 * Collection all reducers
 *
 * @author Mamontov Andrey, 08/2018
 */

import { ActionReducerMap, ActionReducer, MetaReducer, createSelector, createFeatureSelector } from '@ngrx/store';

import * as fromMessages from './messages';
import * as fromUser from './user';
import * as fromVpo from './vpo';
import * as fromStructure from './structure';
import * as fromComplaint from './complaint';
import * as fromSystem from './system';

export interface AppState {
  messages: fromMessages.MessagesState;
  vpo: fromVpo.VpoState;
  user: fromUser.UserState;
  structure: fromStructure.StructureState;
  complaints: fromComplaint.ComplaintState;
  system: fromSystem.SystemState;
}

export const reducers: ActionReducerMap<AppState> = {
  messages: fromMessages.reducer,
  vpo: fromVpo.reducer,
  user: fromUser.reducer,
  structure: fromStructure.reducer,
  complaints: fromComplaint.reducer,
  system: fromSystem.reducer,
};

export function logger(reducer: ActionReducer<AppState>):
  ActionReducer<AppState> {
  return function (state: AppState, action: any): AppState {
    console.log('state', state);
    console.log(`%c action type: ${action.type}`, `color: #03A9F4; font-weight: bold`);
    console.log(`%c action payload: `, `color: #4CAF50; font-weight: bold`, action.payload);
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = [logger];

/**
 * Selectors
 */
export const getMessagesState = createFeatureSelector<AppState>('messages');
export const getUserState = createFeatureSelector<AppState>('user');
export const getVpoState = createFeatureSelector<AppState>('vpo');
export const getStructureState = createFeatureSelector<AppState>('structure');
export const getComplaintState = createFeatureSelector<AppState>('complaints');
export const getSystemState = createFeatureSelector<AppState>('system');

export const selectMessagesState = () => createSelector(
  getMessagesState,
  (m) => m
);

export const selectUserState = () => createSelector(
  getUserState,
  (u) => u
);

export const selectVpoState = () => createSelector(
  getVpoState,
  (v) => v
);

export const selectStructureState = () => createSelector(
  getStructureState,
  (s) => s
);

export const selectComplaintState = () => createSelector(
  getComplaintState,
  (c) => c
);

export const selectSystemState = () => createSelector(
    getSystemState,
    (c) => c
);
